module.exports = __webpack_public_path__ + "media/flags/ci-34147624.svg";